module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1950.743f42c0.svg";